import Tooltip from "bootstrap/js/dist/tooltip";

export const setupTooltip = () => {
	for (const el of document.querySelectorAll('[data-bs-toggle="tooltip"]')) {
		new Tooltip(el);
	}
};

function ready(fn) {
	if (document.readyState !== "loading") {
		fn();
	} else {
		document.addEventListener("DOMContentLoaded", fn);
	}
}

ready(() => {
	setupTooltip();
});
